module.exports = __webpack_public_path__ + "static/media/icon-arrow-up-white.66dff733.svg";